import '../../styles/FormInput.css';
import * as React from 'react';

interface IHorizontalLabelFormInputProps {
    id?: string,
    labelText: string,
    value: string,
    placeHolder?: string,
    readOnly?: boolean,
    required?: boolean
    validationMessage?: string,
    isValid?: boolean,
    erasable?: boolean,
    password?: boolean,
    focused?: boolean,
    onClick?(e?: any): void,
    onBlur?(): void,
    onChange?(value: string): void,
    onFocus?(e?: any): void,
    onErase?(): void,
    onKeyDown?(event: React.KeyboardEvent<HTMLInputElement>): void;
    ignoreValidationBlockSpacing?: boolean;
}

export const LabelledInput = (props: IHorizontalLabelFormInputProps) => {
    const [showPassword, setShowPassword] = React.useState(false);

    // Setup classes for each component
    let labelClass = props.required ? "input-label required" : "input-label";

    let inputClassName = props.isValid ? "input-box" : "input-box-invalid";

    if (props.focused && ((props.readOnly !== undefined && !props.readOnly) || (props.readOnly === undefined))) {
        inputClassName = inputClassName + " focused";
    }
    if (props.required) {
        labelClass = labelClass + " required";
    }

    return (
        <div className="input-container">

            <label className={labelClass}>{props.labelText}</label>
            <div style={{ position: "relative" }}>
                <input
                    id={props.id}
                    className={inputClassName}
                    type={props.password && !showPassword ? "password" : "text"}
                    onChange={(val) => props.onChange(val.target.value)}
                    value={props.value}
                    placeholder={props.placeHolder}
                    readOnly={props.readOnly}
                    onClick={e => {props.onClick ? props.onClick(e) : null}}
                    onBlur={props.onBlur}
                    onFocus={(e) => { props.onFocus ? props.onFocus(e) : null }}
                    onKeyDown={(event) => { props.onKeyDown && props.onKeyDown(event) }}
                    autoComplete="off"
                />
                {
                    props.value !== "" && props.erasable && !props.password ?
                        <span
                            className="glyphicon glyphicon-remove delete-text-input "
                            aria-hidden="true"
                            onClick={() => props.onErase()}
                        />
                        :
                        props.password &&
                        <span
                            className="glyphicon glyphicon-eye-open password-eye-input"
                            aria-hidden="true"
                            onMouseOver={() => setShowPassword(true)}
                            onMouseLeave={() => setShowPassword(false)}
                            onTouchStart={() => setShowPassword(true)}
                            onTouchEnd={() => setShowPassword(false)}
                            onTouchCancel={() => setShowPassword(false)}
                        />
                }
            </div>
            {!props.ignoreValidationBlockSpacing && <span className="valid-block" style={{ visibility: props.isValid ? "hidden" : "visible" }}>{props.validationMessage}</span>}
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/components/customFormComponents/LabelledInput.tsx